/* Free resources and Free webinars, from FreeResources.dc.html and FreeWebinars.dc.html (1440 wide).
   Neither board has a phone version: the phone layout below 760px follows PhoneLibrary.dc.html's
   16px gutter, header and panels. Colours are the tokens file's; the boards' 55% small greys are
   --shell-ink-60, as everywhere in the shell (tokens.css). */

/* The scorecard art's "THE" is Inter Tight at 600, which no other board uses */
@import '@fontsource/inter-tight/latin-600.css';

/* The header both boards share (lines 26 to 57) ------------------------------------------- */
.fp-header {
  height: 72px; display: flex; align-items: center; justify-content: space-between; gap: 24px;
  padding: 0 var(--gutter-header); border-bottom: 1px solid var(--shell-ink-10);
  position: relative; z-index: 5; background: var(--shell-bg);
}
.fp-header-left { display: flex; align-items: center; gap: 28px; min-width: 0; }
.fp-header-right { display: flex; align-items: center; gap: 10px; position: relative; z-index: 30; }
.fp-back, .fw-back {
  display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 600;
  color: var(--shell-ink-66); text-decoration: none;
}
.fp-back:hover, .fw-back:hover { color: var(--shell-ink); }
/* the boards' wordmark has no letter-spacing (Main's has) */
.fp-header .mark--header .mark-name { letter-spacing: 0; }
.fp-round {
  width: 42px; height: 42px; border-radius: 21px; border: 1px solid var(--shell-ink-16);
  background: transparent; color: var(--shell-ink); display: flex; align-items: center; justify-content: center;
  position: relative; flex-shrink: 0;
}
.fp-unread { position: absolute; top: 9px; right: 10px; width: 8px; height: 8px; border-radius: 4px; background: var(--shell-gold); }
.fp-avatar {
  width: 42px; height: 42px; border-radius: 21px; border: 1.5px solid var(--shell-gold); flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 15px;
  color: var(--shell-ink); text-decoration: none;
}

.fp-pop {
  position: absolute; top: 52px; right: 0; background: var(--shell-bg); border: 1px solid var(--shell-ink-12);
  border-radius: 12px; box-shadow: 0 18px 48px var(--shell-ink-14); display: flex; flex-direction: column; color: var(--shell-ink);
}
.fp-pop--search { width: 420px; padding: 10px; gap: 4px; }
.fp-pop--bell { width: 380px; padding: 8px; }
.fp-pop input, .fp-panel input {
  height: 42px; padding: 0 12px; border-radius: 9px; border: 1px solid var(--shell-ink-16);
  background: var(--shell-ink-03); color: var(--shell-ink); font-size: 15px; width: 100%;
}
.fp-pop input::placeholder, .fp-panel input::placeholder { color: var(--shell-ink-60); }
.fp-hint { padding: 6px 6px 2px; font-size: 12px; color: var(--shell-ink-60); }
.fp-pop-head {
  padding: 8px 10px; font-size: 11px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--shell-ink-60);
}
.fp-row { display: flex; flex-direction: column; gap: 2px; padding: 8px 10px; border-radius: 8px; text-decoration: none; color: var(--shell-ink); }
.fp-row:hover { background: var(--shell-ink-04); }
.fp-row--note { padding: 10px; }
.fp-row-label { font-size: 14px; font-weight: 700; }
.fp-row-label--note { line-height: 1.4; }
.fp-row-sub { font-size: 12px; color: var(--shell-ink-60); }
.fp-none { padding: 8px 10px; font-size: 14px; color: var(--shell-ink-60); }

/* The page ----------------------------------------------------------------------------- */
/* the boards' main has 140px under it, with the 72px footer laid over the bottom of the frame: so
   68px between the last section and the footer */
.fp-main { flex: 1; padding: 48px var(--gutter) 68px; display: flex; flex-direction: column; gap: 36px; }
.fp-head { display: flex; align-items: flex-end; justify-content: space-between; gap: 32px; }
.fp-head-text { display: flex; flex-direction: column; gap: 10px; }
.fp-eyebrow { font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); font-weight: 700; }
.fp-h1 { margin: 0; font-size: 44px; font-weight: 800; letter-spacing: -0.01em; }
.fp-lede { margin: 0; font-size: 17px; line-height: 1.55; color: var(--shell-ink-66); max-width: 720px; }
.fp-head-link {
  flex-shrink: 0; height: 44px; padding: 0 18px; border-radius: 10px; border: 1px solid var(--shell-ink-20);
  color: var(--shell-ink); font-weight: 700; font-size: 15px; display: flex; align-items: center; text-decoration: none;
}
.fp-loading { min-height: 40vh; }
.fp-empty { margin: 0; font-size: 16px; line-height: 1.55; color: var(--shell-ink-66); }
.fp-failed { display: flex; flex-direction: column; align-items: flex-start; gap: 14px; }
.fp-failed-line { margin: 0; font-size: 16px; line-height: 1.55; color: var(--shell-ink); max-width: 640px; }

/* Free resources: the cards (lines 70 to 134) ---------------------------------------------- */
.fr-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; align-items: stretch; }
.fr-card {
  display: flex; flex-direction: column; border-radius: 16px; overflow: hidden;
  border: 1px solid var(--shell-ink-10); background: var(--shell-bg);
}
/* the board's hover is 24%; the nearest token, which the Library's cards use, is 30% */
.fr-card:hover { border-color: var(--shell-ink-30); }

.fr-art { height: 200px; padding: 24px; display: flex; flex-direction: column; justify-content: space-between; flex-shrink: 0; }
.fr-art-words { display: flex; flex-direction: column; }
/* an item's own cover photo (3 Nov), filling the top of the card; the panel shows while it's on its way */
.fr-art--cover { position: relative; padding: 0; overflow: hidden; background: var(--shell-ink-04); border-bottom: 1px solid var(--shell-ink-07); }
.fr-cover-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; }
/* the Accelerator's light: The Next Deal Scorecard */
.fr-art--acc-light { background: var(--acc-bg); border-bottom: 1px solid var(--acc-rule); }
.fr-art--acc-light .fr-art-words { gap: 2px; }
.fr-art--acc-light .fr-art-line { font-family: var(--acc-heading-font); font-weight: 600; font-size: 13px; letter-spacing: 0.08em; color: var(--acc-soft); }
.fr-art--acc-light .fr-art-headline { font-family: var(--acc-heading-font); font-weight: 700; font-size: 26px; line-height: 1.1; color: var(--acc-ink); }
.fr-bars-ground { fill: var(--acc-green); }
.fr-bars-bar { fill: var(--acc-bg); }
/* the master brand's light: the 21 Ways guide. The board's rule is 8%; the nearest token is 7% */
.fr-art--master-light { background: var(--shell-ink-03); border-bottom: 1px solid var(--shell-ink-07); }
.fr-art--master-light .fr-art-words { gap: 4px; }
.fr-art-bar { width: 40px; height: 3px; background: var(--shell-gold); }
.fr-art--master-light .fr-art-line { font-weight: 800; font-size: 64px; line-height: 0.95; letter-spacing: -0.02em; }
.fr-art--master-light .fr-art-headline { font-weight: 700; font-size: 16px; line-height: 1.35; color: var(--shell-ink-72); max-width: 280px; }
/* the Accelerator's solid: the Restart Challenge. The board's line is white at 74%; the nearest
   token is 78% */
.fr-art--acc-solid { background: var(--acc-green); }
.fr-art--acc-solid .fr-art-line {
  font-family: var(--acc-body-font); font-size: 12px; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: var(--on-dark-78);
}
.fr-art--acc-solid .fr-art-headline {
  font-family: var(--acc-heading-font); font-weight: 700; font-size: 28px; line-height: 1.15; color: var(--on-dark); max-width: 300px;
}

.fr-body { padding: 22px 22px 24px; display: flex; flex-direction: column; gap: 12px; flex-grow: 1; }
.fr-kind { font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.fr-h2 { margin: 0; font-size: 20px; font-weight: 800; }
.fr-blurb { margin: 0; font-size: 15px; line-height: 1.6; color: var(--shell-ink-70); }
.fr-foot { margin-top: auto; display: flex; flex-direction: column; gap: 10px; padding-top: 8px; }
.fr-btn {
  height: 48px; border-radius: 10px; border: none; background: var(--shell-ink); color: var(--shell-on-ink);
  font-weight: 700; font-size: 15px; display: flex; align-items: center; justify-content: center; gap: 8px;
  text-decoration: none; width: 100%;
}
.fr-btn:hover { color: var(--shell-on-ink); }
.fr-btn--done, .fr-btn--done:hover { background: var(--shell-bg); color: var(--shell-ink); border: 1px solid var(--shell-ink-30); }
.fr-btn:disabled { opacity: 0.55; } /* the shell's 1 disabled look, as Account's */
.fr-btn[aria-busy] { cursor: progress; }
.fr-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); min-height: 40px; }
.fr-note[role="alert"] { color: var(--shell-ink); }

/* a free pack of 2 files or more: each file with its own Download, under the blurb */
.fr-files { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; border-top: 1px solid var(--shell-ink-12); }
.fr-file {
  display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center; gap: 4px 12px;
  padding: 10px 0; border-bottom: 1px solid var(--shell-ink-12);
}
.fr-file-title { font-size: 15px; font-weight: 600; line-height: 1.4; min-width: 0; overflow-wrap: anywhere; }
.fr-btn.fr-btn--file { height: 40px; width: auto; padding: 0 14px; font-size: 14px; }
.fr-file-note { grid-column: 1 / -1; min-height: 0; }

.fr-joined {
  display: flex; flex-direction: column; gap: 8px; padding: 14px 16px; border-radius: 10px;
  border: 1px solid var(--shell-ink-14); background: var(--shell-ink-03);
}
.fr-joined-head { display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 800; }
.fr-tick { stroke: var(--acc-green); }
.fr-joined-line { font-size: 14px; line-height: 1.55; color: var(--shell-ink-72); }

/* the strip under the cards (lines 136 to 139) */
.fr-info {
  display: flex; align-items: flex-start; gap: 14px; padding: 18px 22px; border-radius: 14px;
  background: var(--shell-ink-03); border: 1px solid var(--shell-ink-07);
}
.fr-info-icon { flex-shrink: 0; margin-top: 1px; color: var(--shell-ink); }
.fr-info-text { font-size: 14px; line-height: 1.6; color: var(--shell-ink-72); }

/* Free webinars (FreeWebinars.dc.html lines 59 to 168) ------------------------------------ */
.fp-main--webinars { gap: 34px; }
.fp-main--webinars .fp-lede { max-width: 760px; }
.fw-section { display: flex; flex-direction: column; gap: 16px; }
.fw-section-head { display: flex; align-items: baseline; justify-content: space-between; gap: 20px; }
.fw-h2 { margin: 0; font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); font-weight: 700; }
.fw-aside { font-size: 14px; color: var(--shell-ink-60); }

.fw-card {
  display: grid; grid-template-columns: 240px minmax(0, 1fr) 330px; gap: 28px; align-items: center;
  padding: 26px 28px; border-radius: 16px; border: 1px solid var(--shell-ink-10); scroll-margin-top: 16px;
}
/* the card's thumbnail (Adam, 9 Oct) in the board's date column, or the date block on its grey panel */
.fw-thumb { border-radius: 12px; }
.fw-thumb .fw-date { background: transparent; padding: 0; border-radius: 0; }
.fw-date {
  display: flex; flex-direction: column; align-items: center; gap: 2px; padding: 12px 0; border-radius: 12px; background: var(--shell-ink-04);
}
.fw-date-edge { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; color: var(--shell-ink-60); }
.fw-date-day { font-size: 34px; font-weight: 800; line-height: 1.05; }
.fw-text { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.fw-status { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--shell-ink-66); }
.fw-title { margin: 0; font-size: 23px; font-weight: 800; line-height: 1.25; }
.fw-time { font-size: 15px; color: var(--shell-ink-66); }
.fw-desc { font-size: 15px; line-height: 1.55; color: var(--shell-ink-80); white-space: pre-line; }
.fw-act { display: flex; flex-direction: column; gap: 10px; }
.fw-btn {
  height: 48px; border-radius: 10px; border: none; background: var(--shell-ink); color: var(--shell-on-ink);
  font-weight: 700; font-size: 15px; display: flex; align-items: center; justify-content: center; gap: 8px; text-decoration: none;
}
.fw-btn:hover { color: var(--shell-on-ink); }
.fw-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.icon-fill { fill: currentColor; flex-shrink: 0; }
/* a replay's card (Adam, 23 Oct): the whole card is the link to its own page, its button drawn in it.
   The Library's cards' hover, 30% */
.fw-card--link { color: var(--shell-ink); text-decoration: none; }
.fw-card--link:hover { border-color: var(--shell-ink-30); }

/* A replay's own page (Adam, 23 Oct): the way back, then the player at the top with the title, date and
   description under it. Wider than 1180px the chapters and the call to action, once Play is pressed, sit
   beside it in a column kept for them, so the player is the same size before and after; narrower they
   go under the description. The player's box is the board's (lines 133 to 165), 16:9. A replay that
   will never have anything there for this viewer (no chapters, and no call to action for them) is 1
   column, so the player takes the whole width with no empty column beside it (review of 23 Oct). */
.fp-main--replay { gap: 20px; }
.fw-back { align-self: flex-start; }
.fw-watch {
  display: grid; grid-template-columns: minmax(0, 1fr) 320px; gap: 24px 32px; align-items: start; max-width: 1200px;
}
.fw-watch--solo { grid-template-columns: minmax(0, 1fr); }
.fw-watch-main { display: flex; flex-direction: column; gap: 20px; min-width: 0; }
.fw-watch-text { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.fw-watch-title { margin: 0; font-size: 30px; font-weight: 800; line-height: 1.2; letter-spacing: -0.01em; overflow-wrap: anywhere; }
.fw-watch-desc { margin: 4px 0 0; max-width: 760px; }
/* 16:9 at every width: before Play, while its thumbnail is being signed, with the thumbnail behind the
   button, and once Vimeo plays in it, so it never changes size and a 16:9 replay fills it with no bars.
   It's as wide as its column (in place of the board's fixed height, which cropped a 16:9 thumbnail and
   letterboxed the video). Before Play the whole box is 1 button (.fw-cover, over the thumbnail), so a tap
   anywhere on it plays (review of 23 Oct); the disc sits in its middle row and the line at the foot of the
   row under it, at least 8px below the disc, so the line never covers it, however narrow the box or big
   the text: the disc stays in the middle while there's room, and rises when the line needs it */
.fw-player {
  aspect-ratio: 16 / 9; border-radius: 12px; background: var(--shell-ink); position: relative; overflow: hidden;
}
.fw-player iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; }
.fw-cover {
  position: absolute; inset: 0; z-index: 1; width: 100%; height: 100%; margin: 0; padding: 0;
  border: none; border-radius: inherit; background: transparent; color: var(--on-dark); text-align: left;
  display: grid; grid-template-rows: 1fr auto 1fr; justify-items: center; align-items: center;
}
/* inside the box, since it clips anything outside it: near-black at the edge, white inside it, so the
   ring shows on the dark box (the white) and on any picture (one or the other) */
.fw-cover:focus-visible { outline: 3px solid var(--shell-ink); outline-offset: -3px; box-shadow: inset 0 0 0 6px var(--on-dark); }
.fw-cover:hover .fw-play { border-color: var(--on-dark); }
.fw-play {
  grid-row: 2; position: relative;
  width: 84px; height: 84px; border-radius: 42px; border: 1px solid var(--on-dark-40); background: var(--on-dark-12);
  color: var(--on-dark); display: flex; align-items: center; justify-content: center;
}
.fw-play-line {
  grid-row: 3; align-self: end; justify-self: stretch; position: relative; z-index: 1;
  margin: 8px 24px 20px; font-size: 14px; color: var(--on-dark-80);
}
/* Before Play, the webinar's thumbnail behind the button (Adam, 9 Oct): the button and "Press play" on
   solid near-black, so they read on any picture. The band's margin is the line's less its own padding
   on every side, the top included, so the words stay where they were before the picture came and the
   button doesn't move either, and it stops as far from the right edge as it starts from the left */
.fw-poster { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; }
.fw-player--poster .fw-play { background: var(--shell-ink); border-color: var(--on-dark-40); }
.fw-player--poster .fw-play-line {
  justify-self: start; max-width: calc(100% - 28px); margin: 2px 14px 14px;
  padding: 6px 10px; border-radius: 6px; background: var(--shell-ink); color: var(--on-dark);
}
.fw-side { display: flex; flex-direction: column; gap: 18px; min-width: 0; }
.fw-chapters { display: flex; flex-direction: column; gap: 6px; }
.fw-chapters-head { margin: 0; font-size: 12px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--shell-ink-60); }
.fw-chap {
  display: flex; gap: 12px; padding: 8px 10px; border-radius: 8px; border: none; background: transparent;
  color: var(--shell-ink); text-align: left; font-size: 14px;
}
.fw-chap:hover { background: var(--shell-ink-04); }
.fw-chap-time { min-width: 52px; font-weight: 800; font-variant-numeric: tabular-nums; }
.fw-box {
  padding: 20px; border-radius: 12px; border: 1px solid var(--shell-ink-14); background: var(--shell-bg);
  display: flex; flex-direction: column; gap: 10px;
}
.fw-box-eyebrow {
  display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 700; letter-spacing: 0.12em;
  text-transform: uppercase; color: var(--shell-ink-60);
}
.fw-box-line { font-size: 15px; line-height: 1.55; }
.fw-box-btn {
  height: 44px; border-radius: 10px; background: var(--shell-ink); color: var(--shell-on-ink); font-weight: 700; font-size: 14px;
  display: flex; align-items: center; justify-content: center; text-decoration: none; padding: 0 16px; text-align: center;
}
.fw-box-btn:hover { color: var(--shell-on-ink); }

/* Between a laptop and a phone ---------------------------------------------------------- */
@media (max-width: 1180px) {
  .fr-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .fw-card { grid-template-columns: 200px minmax(0, 1fr) 260px; gap: 22px; }
  .fw-watch { grid-template-columns: minmax(0, 1fr); max-width: 860px; }
}

/* Phone: no board, so PhoneLibrary's gutter, header and panels ---------------------------- */
.fp-header--phone { height: 60px; padding: 0 16px; gap: 10px; }
.fp-header--phone .fp-header-right { gap: 8px; }
.fp-header--phone .fp-round, .fp-header--phone .fp-avatar { width: 40px; height: 40px; border-radius: 20px; }
.fp-header--phone .fp-avatar { font-size: 14px; }
.fp-header--phone .fp-unread { top: 8px; right: 9px; }
.fp-back--phone { align-self: flex-start; min-height: 44px; margin: -12px 0 -14px; }
.fp-panel { border-bottom: 1px solid var(--shell-ink-10); display: flex; flex-direction: column; background: var(--shell-bg); }
.fp-panel--search { padding: 12px 16px; gap: 8px; }
.fp-panel--search input { height: 44px; padding: 0 14px; border-radius: 10px; background: var(--shell-ink-04); font-size: 16px; }
.fp-panel--search .fp-hint { padding: 0 4px; }
.fp-panel--bell { padding: 8px 16px 12px; }
.fp-panel .fp-pop-head { padding: 8px 4px; font-size: 12px; }
.fp-panel .fp-row { padding: 10px 4px; border-radius: 0; border-bottom: 1px solid var(--shell-ink-07); gap: 2px; }
.fp-panel .fp-row-label { font-size: 15px; font-weight: 600; }
.fp-panel .fp-row-sub { font-size: 13px; }
.fp-panel .fp-none { padding: 10px 4px; }

@media (max-width: 760px) {
  .fp-main { padding: 22px 16px 0; gap: 24px; }
  .fp-head { flex-direction: column; align-items: flex-start; gap: 16px; }
  .fp-head-text { gap: 6px; }
  .fp-eyebrow { font-size: 12px; }
  .fp-h1 { font-size: 30px; }
  .fp-lede { font-size: 16px; line-height: 1.5; }

  .fr-grid { grid-template-columns: minmax(0, 1fr); gap: 16px; }
  .fr-art { height: 168px; padding: 20px; }
  .fr-art--master-light .fr-art-line { font-size: 56px; }
  .fr-art--acc-light .fr-art-headline { font-size: 24px; }
  .fr-art--acc-solid .fr-art-headline { font-size: 26px; }
  .fr-body { padding: 18px 18px 20px; gap: 10px; }
  .fr-note { min-height: 0; }
  .fr-info { padding: 16px; gap: 12px; }

  .fw-section { gap: 12px; }
  .fw-section-head { flex-direction: column; align-items: flex-start; gap: 4px; }
  .fw-card { grid-template-columns: minmax(0, 1fr); gap: 14px; align-items: start; padding: 16px; }
  .fw-thumb { border-radius: 10px; }
  .fw-thumb .fw-date-day { font-size: 34px; }
  .fw-date { padding: 10px 0; border-radius: 10px; }
  .fw-date-edge { font-size: 11px; }
  .fw-date-day { font-size: 26px; }
  .fw-text { gap: 6px; }
  .fw-title { font-size: 19px; }
  .fw-time, .fw-desc { font-size: 14px; }
  .fw-act { grid-column: 1 / -1; }
  .fw-watch { gap: 24px; }
  .fw-watch-main { gap: 16px; }
  .fw-watch-text { gap: 6px; }
  .fw-watch-title { font-size: 23px; }
  .fw-play { width: 64px; height: 64px; border-radius: 32px; }
  .fw-play-line { margin: 8px 16px 12px; font-size: 13px; }
  .fw-player--poster .fw-play-line { max-width: calc(100% - 12px); margin: 2px 6px 6px; }
  .fw-box { padding: 16px; }
}

/* A narrow phone (340px and under): a smaller play button, so the longest line under it fits on 2 lines */
@media (max-width: 340px) {
  .fw-play { width: 48px; height: 48px; border-radius: 24px; }
  .fw-play svg { width: 22px; height: 22px; }
}

/* Free resources: the line back to the property strategy report (Stage 2), only for an account with a saved report */
.fr-strategy { margin: 0 0 20px; font-size: 15px; font-weight: 600; }
.fr-strategy a { color: inherit; text-decoration: underline; text-underline-offset: 3px; }
/* The starter guide under it (Stage 2, S2.8) */
.fr-strategy-guide { margin: -12px 0 20px; font-size: 15px; font-weight: 600; }
.fr-strategy-guide a { color: inherit; text-decoration: underline; text-underline-offset: 3px; }
